import { useUSDCMetadata } from '@components/Web3/UserOpTxModal/usdc/qr-fund/useUSDCAddress'
import { useQuery } from '@tanstack/react-query'
import { useTownsContext } from 'use-towns-client'
import { Address, encodeFunctionData, erc20Abi, formatUnits } from 'viem'

export const usdcBalanceQueryKey = (
    address: Address | undefined,
    usdcAddress: Address | undefined,
) => ['usdcBalance', address ?? 'waitingForAddress', usdcAddress ?? 'waitingForAddress']

export function useUSDCBalance({
    address,
    enabled = true,
    refetchInterval = 6_000,
}: {
    address: Address | undefined
    enabled?: boolean
    refetchInterval?: number
}) {
    const { baseProvider } = useTownsContext()
    const { address: usdcAddress } = useUSDCMetadata()

    return useQuery({
        queryKey: usdcBalanceQueryKey(address, usdcAddress),
        queryFn: async () => {
            if (!address || !usdcAddress) {
                return undefined
            }

            const balance = await baseProvider.call({
                to: usdcAddress,
                data: encodeFunctionData({
                    abi: erc20Abi,
                    functionName: 'balanceOf',
                    args: [address],
                }),
            })

            return BigInt(balance)
        },
        select: (data) => {
            if (!data) {
                return undefined
            }

            return {
                decimals: 6,
                symbol: 'USDC',
                formatted: formatUnits(data, 6),
                value: data,
            }
        },
        enabled: enabled && !!address && !!usdcAddress,
        refetchInterval,
        staleTime: 60_000,
        gcTime: 60_000 * 5,
    })
}
